import AbnormalOrderRecordType from "../enum/AbnormalOrderRecordType";

const AbnormalOrderRecordTypeNameMap = {
    [AbnormalOrderRecordType.CONSIGNEE_CHANGED]: "打印后改地址",
    [AbnormalOrderRecordType.ORDER_CANCELED]: "打印后待发货订单被取消",
    [AbnormalOrderRecordType.ORDER_CANCELED_AFTER_SHIPPED]: "发货后订单被取消",
    [AbnormalOrderRecordType.ORDER_ITEM_CANCELED]: "打印后商品项被取消",
    [AbnormalOrderRecordType.ORDER_ITEM_CANCELED_AFTER_SHIPPED]: "发货后商品项被取消",
    [AbnormalOrderRecordType.ORDER_ITEM_PART_QUANTITY_CANCELED]: "打印后商品部分数量被取消",
    [AbnormalOrderRecordType.REFUNDING_APPLIED]: "打印后退款",
    [AbnormalOrderRecordType.SELLER_REMARKS_MODIFIED]: "打印后改备注",
    [AbnormalOrderRecordType.SKU_PROPERTIES_MODIFIED]: "打印后改属性",
};

export default AbnormalOrderRecordTypeNameMap;
